import {
  ArraySectionsType,
  FormActionType,
  FormEventType,
  FormTabType,
} from '@pages/WindowsCreateOrEdit/types'

import { FIELD_BIND_TYPE } from '@constants'
import { GETWindowDTO } from '@types'

export const getTransformDataForReset = (windowById: GETWindowDTO | ArraySectionsType) => {
  const transformTab = (tab: any): FormTabType => ({
    id: tab.id,
    title: tab.title || '',
    order: tab.order || null,
    object: tab.objectCode ? { id: tab.objectCode, label: tab.objectTitle } : null,
    entity: tab.entityId ? { id: tab.entityId, label: tab.entityTitle || '' } : null,
    entityType: tab.entityType ? { id: tab.entityType, label: tab.entityType } : null,
    conditions: tab.conditions || '',
    actions: tab.actions?.map(transformAction) || [],
  })

  const transformAction = (action: any): FormActionType => ({
    id: action.id,
    actionTitle: action.actionCode ? { id: action.actionCode, label: action.actionTitle } : null,
    events: action.events?.map(transformEvent) || [],
  })

  const transformEvent = (event: any): FormEventType => ({
    id: event.id,
    event:
      event.eventCode && event.eventTitle ? { id: event.eventCode, label: event.eventTitle } : null,
    postVariable: event.varId && event.varTitle ? { id: event.varId, label: event.varTitle } : null,
    valueType: event.valueType
      ? { id: event.valueType, label: FIELD_BIND_TYPE[event.valueType] }
      : null,
    value: event.value || null,
    pathArray: event.pathArray ?? null,
  })

  const resetData: ArraySectionsType = {
    id: windowById.id || null,
    title: windowById.title || '',
    internalId: windowById.internalId || '',
    filterSectionUuid: windowById.filterSectionUuid || null,
    filter: windowById.filterId
      ? { id: windowById.filterId, label: windowById.filterTitle || '' }
      : null,
    filterSection: windowById.filterSectionId
      ? {
          id: windowById.filterSectionId,
          label: windowById.filterSectionTitle || '',
        }
      : null,
    sections:
      windowById.sections?.map(section => ({
        id: section.id || null,
        title: section.title || '',
        uuid: section.uuid || null,
        tabs: section.tabs?.map(transformTab) || [],
      })) || [],
    vars: windowById.vars || [],
    configs: windowById.configs || null,
  }

  return resetData
}
